import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorPreviewV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorPreviewV3Controller.php
* @route '/api/editor/{type}/{document}/{dossier}/preview-v3'
*/
const GetDocumentEditorPreviewV3Controller = (args: { type: string | number, document: string | number, dossier: string | number | { id: string | number } } | [type: string | number, document: string | number, dossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetDocumentEditorPreviewV3Controller.url(args, options),
    method: 'post',
})

GetDocumentEditorPreviewV3Controller.definition = {
    methods: ["post"],
    url: '/api/editor/{type}/{document}/{dossier}/preview-v3',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorPreviewV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorPreviewV3Controller.php
* @route '/api/editor/{type}/{document}/{dossier}/preview-v3'
*/
GetDocumentEditorPreviewV3Controller.url = (args: { type: string | number, document: string | number, dossier: string | number | { id: string | number } } | [type: string | number, document: string | number, dossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
            dossier: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDocumentEditorPreviewV3Controller.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\GetDocumentEditorPreviewV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/GetDocumentEditorPreviewV3Controller.php
* @route '/api/editor/{type}/{document}/{dossier}/preview-v3'
*/
GetDocumentEditorPreviewV3Controller.post = (args: { type: string | number, document: string | number, dossier: string | number | { id: string | number } } | [type: string | number, document: string | number, dossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetDocumentEditorPreviewV3Controller.url(args, options),
    method: 'post',
})

export default GetDocumentEditorPreviewV3Controller